import { render, staticRenderFns } from "./FbCheckbox.vue?vue&type=template&id=49cccf02&scoped=true"
import script from "./FbCheckbox.vue?vue&type=script&lang=js"
export * from "./FbCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FbCheckbox.vue?vue&type=style&index=0&id=49cccf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cccf02",
  null
  
)

export default component.exports